import { createIconComponent } from '../../factory/create-icon-component';
export const CzechRepublicIcon = createIconComponent(
  'CzechRepublicIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10086_33079)">
      <path d="M23 5H1V20H23V5Z" fill="#0052B4" />
      <path d="M23 12.5V20H1L10.2462 12.5H23Z" fill="#D80027" />
      <path d="M23 5V12.5H10.2462L1 5H23Z" fill="#F0F0F0" />
    </g>
    <defs>
      <clipPath id="clip0_10086_33079">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
